export const isImportMetaEnvFlagEnabled = (value: unknown) =>
  value === true || value === 'true';
